export default __webpack_public_path__ + "static/media/badge-best-value@2x.86a4cada.png";